package com.wintermar.inspection.feature.presentation.inspection.answer.widget

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.input.InputTextAutocomplete
import com.wintermar.inspection.core.ui.component.input.util.InputState
import com.wintermar.inspection.core.ui.component.input.util.InputStateModel
import com.wintermar.inspection.core.ui.util.SelectionModel

@Composable
fun VesselAnswer(
    value: String,
    references: List<SelectionModel>,
    onClick: (SelectionModel) -> Unit
) {
    val scope = rememberCoroutineScope()
    val inputState = remember {
        InputState(
            initialData = InputStateModel(
                value = value,
                placeholder = "Your response"
            ),
            scope
        )
    }

    Column(
        modifier = Modifier.fillMaxWidth(),
    ) {
        InputTextAutocomplete(
            state = inputState,
            references = references,
            modifier = Modifier.fillMaxWidth(),
            onClick = {
                onClick(it)
            })
    }
}
